export default __webpack_public_path__ + "static/media/s2_male.87f9aab8.wav";